export enum ShopsRequestStatusAction {
  Load = '[Shops] [Request Status] Load',
  Success = '[Shops] [Request Status] Success',
  Error = '[Shops] [Request Status] Error',
}
